import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { fetchRestaurantOpenDays, patchRestaurantOpenDays, createRestaurantOpenDays, fetchHoursEach, fetchRestaurantDetails } from "../../actions/restaurantActions";
import DropDownButton from "../../components/DropDownButton";
import CustomSelectArray from "../CustomSelectArray";
import { api } from "../../App";
import { CustomModal } from "../CustomModal";
import { ModernButton, InlineText, InsideFormGroup, FormGroup, Input, StyledLabel } from "../../components/DefaultImports";
import TimeRangePicker from "../inputs/TimeRangePicker";
import { ConfirmationModal } from "../ConfirmationModal";
import { hasCompletoFeatures } from "../../utils/planFeatures";
const BlockedInputWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;

  input {
    ${({
  $blocked
}) => $blocked ? `
          padding-right: 34px;
          cursor: pointer;
          border-color: #ee754c !important;
          background-color: #fff7f4 !important;
          box-shadow: 0 0 0 1px rgba(238, 117, 76, 0.18);
        ` : ""}
  }
`;
const BlockedInputOverlay = styled.span`
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 10px;
  color: #ee754c;
  cursor: pointer;
  border-radius: 6px;

  svg {
    filter: drop-shadow(0 1px 1px rgba(255, 255, 255, 0.85));
  }
`;
const UpgradeModalContent = styled.div`
  padding: 8px 2px;
`;
const UpgradeModalText = styled.p`
  margin: 0 0 18px;
  color: #343a38;
`;
const UpgradeModalButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;
`;
function TimeManagement({
  shiftId = null,
  mode = "create",
  scheduleType = "regular",
  restaurantId,
  showModal,
  setShowModal
}) {
  const {
    t
  } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [timeStart, setTimeStart] = useState("12:00");
  const [timeEnd, setTimeEnd] = useState("22:00");
  const [shift, setShift] = useState("Dinner");
  const [selectedItems, setSelectedItems] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showArrivalControlUpgradeModal, setShowArrivalControlUpgradeModal] = useState(false);
  const [switchZones, setSwitchZones] = useState(mode === "create" ? false : true);
  const [zone_list, setZone_list] = useState([]);
  const [selectedZones, setSelectedZones] = useState([]);
  const [accept_people_per_each_time, setAccept_people_per_each_time] = useState(20);
  const [eachTime, setEachTime] = useState("00:15");
  const hoursEachTime = useSelector(state => state.hoursEachTime);
  const {
    hoursEach
  } = hoursEachTime;
  const openDayss = useSelector(state => state.restaurantOpenDaysOfTheWeek);
  const {
    openDays = [],
    isLoadingOpenDays
  } = openDayss;
  const restaurantZones = useSelector(state => state.restaurantZones);
  const {
    zones = []
  } = restaurantZones;
  const restaurantDetails = useSelector(state => state.restaurantDetails);
  const {
    restaurants
  } = restaurantDetails;
  const isCurrentRestaurantLoaded = restaurants && Number(restaurants.id) === Number(restaurantId);
  const isArrivalControlBlocked =
    !isCurrentRestaurantLoaded || !hasCompletoFeatures(restaurants);
  const displayedArrivalLimit = isArrivalControlBlocked ? "" : accept_people_per_each_time;
  useEffect(() => {
    dispatch(fetchHoursEach(restaurantId));
  }, [dispatch, restaurantId]);
  useEffect(() => {
    if (restaurantId) {
      dispatch(fetchRestaurantDetails(restaurantId));
    }
  }, [dispatch, restaurantId]);
  useEffect(() => {
    const placeOfTables = zones.map(zone => zone.place_of_table);
    setZone_list(placeOfTables);
    if (!switchZones) {
      setSelectedZones(placeOfTables);
    }
  }, [zones, switchZones]);
  useEffect(() => {
    if (mode === "edit" && shiftId && openDays.length > 0) {
      const openDay = openDays.find(day => day.id === shiftId);
      if (openDay) {
        setShift(openDay.shift);
        setTimeStart(openDay.start_time.slice(0, 5));
        setTimeEnd(openDay.end_time.slice(0, 5));
        setAccept_people_per_each_time(openDay.accept_people_per_each_time);
        setEachTime(openDay.each_time);
        setSelectedZones(openDay.list_of_zones ? openDay.list_of_zones.split(",") : []);
        const selected = [];
        if (openDay.Monday) selected.push("Segunda");
        if (openDay.Tuesday) selected.push("Terça");
        if (openDay.Wednesday) selected.push("Quarta");
        if (openDay.Thursday) selected.push("Quinta");
        if (openDay.Friday) selected.push("Sexta");
        if (openDay.Saturday) selected.push("Sábado");
        if (openDay.Sunday) selected.push("Domingo");
        setSelectedItems(selected);
      }
    }
  }, [mode, shiftId, openDays]);
  const handleFormSubmit = event => {
    event.preventDefault();
    const openDaysDataToSubmit = {
      restaurant: restaurantId,
      start_time: timeStart,
      end_time: timeEnd,
      Monday: selectedItems.includes("Segunda"),
      Tuesday: selectedItems.includes("Terça"),
      Wednesday: selectedItems.includes("Quarta"),
      Thursday: selectedItems.includes("Quinta"),
      Friday: selectedItems.includes("Sexta"),
      Saturday: selectedItems.includes("Sábado"),
      Sunday: selectedItems.includes("Domingo"),
      accept_people_per_each_time: Number(accept_people_per_each_time),
      each_time: eachTime,
      list_of_zones: selectedZones.join(",")
    };
    if (mode === "edit") {
      dispatch(patchRestaurantOpenDays(restaurantId, shiftId, openDaysDataToSubmit));
    } else {
      dispatch(createRestaurantOpenDays(restaurantId, openDaysDataToSubmit));
    }
    setShowModal(false);
  };
  const deleteOpenDay = async () => {
    try {
      await api.delete(`restaurants/${restaurantId}/opentimes/${shiftId}/`);
      dispatch(fetchRestaurantOpenDays(restaurantId));
      setShowModal(false);
      setShowDeleteModal(false);
    } catch (error) {
      console.error(error);
    }
  };
  const handleSelectZones = newSelectedItems => {
    setSelectedZones(newSelectedItems);
  };
  const handleViewPlans = () => {
    setShowArrivalControlUpgradeModal(false);
    navigate(`/pick_plan_and_pay/${restaurantId}`);
  };
  const weekdayDisplayMap = {
    Segunda: t("ui.components.restaurantSchedule.regularShiftManagement.weekdays.monday"),
    Terça: t("ui.components.restaurantSchedule.regularShiftManagement.weekdays.tuesday"),
    Quarta: t("ui.components.restaurantSchedule.regularShiftManagement.weekdays.wednesday"),
    Quinta: t("ui.components.restaurantSchedule.regularShiftManagement.weekdays.thursday"),
    Sexta: t("ui.components.restaurantSchedule.regularShiftManagement.weekdays.friday"),
    Sábado: t("ui.components.restaurantSchedule.regularShiftManagement.weekdays.saturday"),
    Domingo: t("ui.components.restaurantSchedule.regularShiftManagement.weekdays.sunday")
  };
  const displayToInternal = label => {
    return Object.keys(weekdayDisplayMap).find(key => weekdayDisplayMap[key] === label) || label;
  };
  const internalToDisplay = key => weekdayDisplayMap[key] || key;
  return <div>
      <form onSubmit={handleFormSubmit}>
        <div>
          <StyledLabel htmlFor="weekdays">{t("ui.components.restaurantSchedule.regularShiftManagement.diasDaSemana")}</StyledLabel>

          <CustomSelectArray items={Object.values(weekdayDisplayMap)} selectedItems={selectedItems.map(internalToDisplay)} onSelectChange={newDisplayValues => setSelectedItems(newDisplayValues.map(displayToInternal))} size="large" wrap={true} />
        </div>

        <div style={{
        marginBottom: "16px"
      }}>
          <StyledLabel>{t("ui.components.restaurantSchedule.regularShiftManagement.horarioDoTurno")}</StyledLabel>

          <TimeRangePicker startTime={timeStart} endTime={timeEnd} onChange={times => {
          setTimeStart(times[0]);
          setTimeEnd(times[1]);
        }} />
        </div>

        <div style={{
        marginBottom: "16px"
      }}>
          <FormGroup>
            <InsideFormGroup>
              <StyledLabel>{t("ui.components.restaurantSchedule.regularShiftManagement.controlarChegadaDeClientes")}</StyledLabel>

              <InlineText>{t("ui.components.restaurantSchedule.regularShiftManagement.permitirNoTotal")}</InlineText>

              <BlockedInputWrapper $blocked={isArrivalControlBlocked}>
                <Input type="number" id="accept_people_per_each_time" name="accept_people_per_each_time" value={displayedArrivalLimit} readOnly={isArrivalControlBlocked} aria-disabled={isArrivalControlBlocked} onChange={event => {
                if (isArrivalControlBlocked) {
                  return;
                }
                setAccept_people_per_each_time(event.target.value);
              }} />

                {isArrivalControlBlocked && <BlockedInputOverlay role="button" tabIndex={0} title={t("ui.components.restaurantSchedule.regularShiftManagement.verPlanosComAcessoAEsta")} aria-label={t("ui.components.restaurantSchedule.regularShiftManagement.atualizarOPlanoParaAlterarO")} onClick={() => setShowArrivalControlUpgradeModal(true)} onKeyDown={event => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  setShowArrivalControlUpgradeModal(true);
                }
              }}>
                    <FontAwesomeIcon icon={faLock} />
                  </BlockedInputOverlay>}
              </BlockedInputWrapper>

              <InlineText>{t("ui.components.restaurantSchedule.regularShiftManagement.pessoasACada")}</InlineText>

              <DropDownButton options={["00:15", "00:30", "00:45"]} handleOptionChange={selected => setEachTime(selected)} initialOption={eachTime} />

              <InlineText>{t("ui.components.restaurantSchedule.regularShiftManagement.minutos")}</InlineText>
            </InsideFormGroup>
          </FormGroup>

          <FormGroup />

          <FormGroup controlId="zones">
            <StyledLabel>{t("ui.components.restaurantSchedule.regularShiftManagement.selecionarSalas")}</StyledLabel>

            <CustomSelectArray items={zone_list} onSelectChange={handleSelectZones} selectedItems={selectedZones} size="large" />
          </FormGroup>
        </div>

        <div style={{
        display: "flex",
        justifyContent: "flex-end",
        gap: "10px",
        marginTop: "16px"
      }}>
          {mode === "edit" && <ModernButton color="#99b0ad" fontSize="14px" type="button" onClick={() => setShowDeleteModal(true)}>{t("ui.components.restaurantSchedule.regularShiftManagement.apagar")}</ModernButton>}

          <ModernButton color="#ff704d" fontSize="14px" type="submit">{t("ui.components.restaurantSchedule.regularShiftManagement.gravar")}</ModernButton>
        </div>
      </form>

      <ConfirmationModal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} onConfirm={deleteOpenDay} title={t("ui.components.restaurantSchedule.regularShiftManagement.eliminarTurno")} body={t("ui.screens.restaurantTimeManagement.temACertezaQueDesejaEliminar")} confirmLabel={t("ui.components.reservationStatusBox.confirmar")} confirmColor="#ff704d" cancelLabel={t("common.cancel")} cancelColor="#99b0ad" centered={false} topSpacing="150px auto" />

      <CustomModal show={showArrivalControlUpgradeModal} onHide={() => setShowArrivalControlUpgradeModal(false)} title={t("ui.components.restaurantSchedule.regularShiftManagement.controlarChegadaDeClientes2")}>
        <UpgradeModalContent>
          <UpgradeModalText>{t("ui.components.restaurantSchedule.regularShiftManagement.aConfiguracaoDoTotalDePessoas")}</UpgradeModalText>

          <UpgradeModalButtons>
            <ModernButton type="button" color="#99b0ad" onClick={() => setShowArrivalControlUpgradeModal(false)}>{t("ui.components.restaurantSchedule.regularShiftManagement.agoraNao")}</ModernButton>

            <ModernButton type="button" color="#ee754c" onClick={handleViewPlans}>{t("ui.components.restaurantSchedule.regularShiftManagement.verPlanos")}</ModernButton>
          </UpgradeModalButtons>
        </UpgradeModalContent>
      </CustomModal>
    </div>;
}
export default TimeManagement;
